module.exports = __webpack_public_path__ + "static/media/img_Benchmarking103.ac8a4e4c.png";